import { Outlet } from 'react-router';
import useGlobalDataFetcherListener from '../../hooks/global-reducer/useGlobalDataFetcherListener';
import { useFetchUponCrmOrgChange } from '../../hooks/useFetchUponCrmOrgChange';
import useCrmOrgFromUrl from '../../hooks/useCrmOrgFromUrl';

const HomeInitialized = () => {
  //Here goes initializations that DO require "crmOrgs" or "hubspot" to be initialized:
  useGlobalDataFetcherListener();
  useFetchUponCrmOrgChange();
  useCrmOrgFromUrl();

  //Child routes are defined in AppRoutes.tsx //
  return <Outlet />;
};

export default HomeInitialized;
